/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { useDisplayTheme } from 'hooks/useUiState'
import { InsightViewOptionStrings } from 'enums/InsightViewOption'
import { DonutMetricItem, GaugeMetricItem, BarMetricItem } from './charts'
import {
  convertToDonutData,
  convertToGaugeData,
  convertToRoundBarData,
  createDonutOptions,
  createGaugeOptions,
  valueFormatter,
  convertToScaleBarData,
  AutoIdWrapper,
  getExplanation,
  percentFormatter,
  createDisabledInfo
} from './utils'
import { ChartConfig, ChartType } from './types'

export interface MetricItemProps {
  chartConfig: ChartConfig
  viewOption: InsightViewOptionStrings
}

const MetricItem = ({ chartConfig, viewOption }: MetricItemProps) => {
  const theme = useDisplayTheme()
  switch (chartConfig.type) {
    case ChartType.DONUT: {
      const { chartOptions, legendOptions } = createDonutOptions(chartConfig, viewOption)
      // N/A
      return (
        <DonutMetricItem
          data={convertToDonutData(chartConfig)}
          chartOptions={chartOptions}
          legendOptions={legendOptions}
          explanation={getExplanation(chartConfig, viewOption)}
          disabledInfo={createDisabledInfo(chartConfig)}
        />
      )
    }
    case ChartType.SPEED_DIAL: {
      const { chartOptions, legendOptions } = createGaugeOptions(chartConfig, viewOption)
      return (
        <GaugeMetricItem
          data={convertToGaugeData(chartConfig, viewOption)}
          chartOptions={chartOptions}
          legendOptions={legendOptions}
          explanation={getExplanation(chartConfig, viewOption)}
          disabledInfo={createDisabledInfo(chartConfig)}
        />
      )
    }
    case ChartType.ROUND_BAR: {
      return (
        <BarMetricItem
          data={convertToRoundBarData(chartConfig, theme)}
          metricTitle={chartConfig.label || ''}
          total={valueFormatter(chartConfig.value)}
          percentVariation={
            chartConfig.delta && {
              trend: chartConfig.delta.direction,
              value: chartConfig.delta.value
            }
          }
          explanation={getExplanation(chartConfig, viewOption)}
          disabledInfo={createDisabledInfo(chartConfig)}
        />
      )
    }
    case ChartType.SCALE_BAR: {
      return (
        <BarMetricItem
          data={convertToScaleBarData(chartConfig, theme)}
          metricTitle={chartConfig.label || ''}
          total={percentFormatter(chartConfig.value)}
          percentVariation={
            chartConfig.delta && {
              trend: chartConfig.delta.direction,
              value: chartConfig.delta.value
            }
          }
          explanation={getExplanation(chartConfig, viewOption)}
          disabledInfo={createDisabledInfo(chartConfig)}
        />
      )
    }
    default:
      console.warn('chart not implemented')
      return null
  }
}

const MetricItemWithAutoId = (metricItemProps: MetricItemProps) => (
  <AutoIdWrapper>
    <MetricItem {...metricItemProps} />
  </AutoIdWrapper>
)

export default MetricItemWithAutoId
